import axios from 'axios';

import { IntelligentEscalationDto } from '../dtos/property-question.dto.interface';

class IntelligentEscalationService {
  async get(propertyId: string): Promise<IntelligentEscalationDto[]> {
    const response = await axios.get(`intelligent-escalation/${propertyId}`);

    return response.data;
  }

  async answer(escalationId: string, answer: string): Promise<IntelligentEscalationDto> {
    const response = await axios.post(`intelligent-escalation/answer/${escalationId}`, {
      answer,
    });

    return response.data;
  }

  async ignore(escalationId: string): Promise<IntelligentEscalationDto> {
    const response = await axios.put(`intelligent-escalation/ignore/${escalationId}`);

    return response.data;
  }
}

export default new IntelligentEscalationService();
